import { atom, useAtom } from 'jotai'

/** 마우스 hover된 센터(컬럼) 코드 - 컬럼 단위 hover 강조용 */
const hoveredWarehouseAtom = atom<string | null>(null)

export const useHoveredWarehouse = () => useAtom(hoveredWarehouseAtom)
